// extracted by css-extract-rspack-plugin
export default {"tableHeader":"tableHeader-u2Kcj2","headerText":"headerText-UXq3jV"};